import ZCheckboxGroup from '../checkbox/checkbox-group.vue'

ZCheckboxGroup.install = function(app) {
  app.component(ZCheckboxGroup.name, ZCheckboxGroup)
}

export default ZCheckboxGroup